var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.pageValue)+" "),(_vm.encryptValue)?_c('div',{staticStyle:{"display":"inline-block"},on:{"click":_vm.setIconStatus}},[_c('icon-svg',{attrs:{"name":_vm.iconName}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }